import React from 'react';

function SearchConsole() {
  return (
    <div style={{ textAlign: 'center', marginTop: '2rem' }}>
      <h1>Welcome to the SearchConsole Page!</h1>
      <p>Here you can view and manage your reports.</p>
      <iframe width="90%" height="600" src="https://analytics.zoho.in/open-view/406343000000004069/668c28bde04b243277cfeff8d169bf29"></iframe>    </div>
  );
}

export default SearchConsole;
